<template>
  <!-- Material Symbols "family_history". Not in the classic Material Icons font
       we bundle, so it's registered as a Vuetify component icon (see
       src/plugins/vuetify.js) rather than a ligature. Uses the Symbols 960-unit
       viewBox; sizes to 1em and inherits color so `size`/`color` on <v-icon> work. -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    width="1em"
    height="1em"
    fill="currentColor"
    role="img"
    aria-hidden="true"
  >
    <path
      d="M373.5-103.5Q330-147 330-210q0-52 31-91.5t79-53.5v-85H200v-160H100v-280h280v280H280v80h400v-85q-48-14-79-53.5T570-750q0-63 43.5-106.5T720-900q63 0 106.5 43.5T870-750q0 52-31 91.5T760-605v165H520v85q48 14 79 53.5t31 91.5q0 63-43.5 106.5T480-60q-63 0-106.5-43.5Zm396-597Q790-721 790-750t-20.5-49.5Q749-820 720-820t-49.5 20.5Q650-779 650-750t20.5 49.5Q691-680 720-680t49.5-20.5ZM180-680h120v-120H180v120Zm349.5 519.5Q550-181 550-210t-20.5-49.5Q509-280 480-280t-49.5 20.5Q410-239 410-210t20.5 49.5Q451-140 480-140t49.5-20.5ZM240-740Zm480-10ZM480-210Z"
    />
  </svg>
</template>

<script>
export default {
  name: "FamilyHistoryIcon",
};
</script>
